import { Dispatch } from 'redux';
import { Moment } from 'moment';
import { OrderedMap } from 'immutable';

import { fetcher } from '../../lib/request';
import Format from '../../models/Afisha/Format';

const AFISHA_HOST = process.env.REACT_APP_AFISHA_HOST;
const AFISHA_KEY = process.env.REACT_APP_AFISHA_KEY;

export const GET_SCHEDULE_REQUEST = 'AFISHA_GET_SCHEDULE_REQUEST';
export const GET_SCHEDULE_RESPONSE = 'AFISHA_GET_SCHEDULE_RESPONSE';
export const GET_SCHEDULE_ERROR = 'AFISHA_GET_SCHEDULE_ERROR';

export const RESET_SCHEDULE = 'AFISHA_RESET_SCHEDULE';

export const GET_MORE_SCHEDULE_REQUEST = 'AFISHA_GET_MORE_SCHEDULE_REQUEST';
export const GET_MORE_SCHEDULE_RESPONSE = 'AFISHA_GET_MORE_SCHEDULE_RESPONSE';
export const GET_MORE_SCHEDULE_ERROR = 'AFISHA_GET_MORE_SCHEDULE_ERROR';

export const GET_SCHEDULE_EVENT_REQUEST = 'AFISHA_GET_SCHEDULE_EVENT_REQUEST';
export const GET_SCHEDULE_EVENT_RESPONSE = 'AFISHA_GET_SCHEDULE_EVENT_RESPONSE';
export const GET_SCHEDULE_EVENT_ERROR = 'AFISHA_GET_SCHEDULE_EVENT_ERROR';

export const GET_MORE_SCHEDULE_EVENT_REQUEST = 'AFISHA_GET_MORE_SCHEDULE_EVENT_REQUEST';
export const GET_MORE_SCHEDULE_EVENT_RESPONSE = 'AFISHA_GET_MORE_SCHEDULE_EVENT_RESPONSE';
export const GET_MORE_SCHEDULE_EVENT_ERROR = 'AFISHA_GET_MORE_SCHEDULE_EVENT_ERROR';

export const GET_SCHEDULE_EVENT_FORMAT_REQUEST = 'AFISHA_GET_SCHEDULE_EVENT_FORMAT_REQUEST';
export const GET_SCHEDULE_EVENT_FORMAT_RESPONSE = 'AFISHA_GET_SCHEDULE_EVENT_FORMAT_RESPONSE';
export const GET_SCHEDULE_EVENT_FORMAT_ERROR = 'AFISHA_GET_SCHEDULE_EVENT_FORMAT_ERROR';

export const GET_SCHEDULE_PLACE_FORMAT_REQUEST = 'AFISHA_GET_SCHEDULE_PLACE_FORMAT_REQUEST';
export const GET_SCHEDULE_PLACE_FORMAT_RESPONSE = 'AFISHA_GET_SCHEDULE_PLACE_FORMAT_RESPONSE';
export const GET_SCHEDULE_PLACE_FORMAT_ERROR = 'AFISHA_GET_SCHEDULE_PLACE_FORMAT_ERROR';

export const TOGGLE_EVENT_FORMAT = 'AFISHA_TOGGLE_EVENT_FORMAT';
export const TOGGLE_PLACE_FORMAT = 'AFISHA_TOGGLE_PLACE_FORMAT';

export const RESET_FORMATS = 'RESET_FORMATS';

export const getScheduleAction = (
    id: string,
    dateFrom: Moment,
    dateTo: Moment | null,
    formats: OrderedMap<number, Format>,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_SCHEDULE_REQUEST
    });
    
    try {
        if (!lang) {
            lang = 'ru';
        }
        
        const dates = `date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        let formatsQuery = '';
        if (formats) {
            for (let format of formats.toArray()) {
                formatsQuery += '&formats[]=' + format.id;
            }
        }
        const response = await fetcher(`${AFISHA_HOST}/api/v3/places/${id}/schedule?${dates}${formatsQuery}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();
        
        dispatch({
            type: GET_SCHEDULE_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_SCHEDULE_ERROR,
            error: error
        });
    }
};

export const resetScheduleAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_SCHEDULE
    });
};

export const getMoreScheduleAction = (
    id: string,
    dateFrom: Moment,
    dateTo: Moment | null,
    page: number,
    formats: OrderedMap<number, Format>,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_MORE_SCHEDULE_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        let formatsQuery = '';
        if (formats) {
            for (let format of formats.toArray()) {
                formatsQuery += '&formats[]=' + format.id;
            }
        }

        const response = await fetcher(`${AFISHA_HOST}/api/v3/places/${id}/schedule?${dates}${formatsQuery}&page=${page}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_MORE_SCHEDULE_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_MORE_SCHEDULE_ERROR,
            error: error
        });
    }
};

export const getScheduleEventAction = (
    id: string,
    city: number,
    dateFrom: Moment,
    dateTo: Moment | null,
    formats: OrderedMap<number, Format>,
    lang: string,
    q?: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_SCHEDULE_EVENT_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        let formatsQuery = '';
        if (formats) {
            for (let format of formats.toArray()) {
                formatsQuery += '&formats[]=' + format.id;
            }
        }
        const response = await fetcher(`${AFISHA_HOST}/api/v3/events/${id}/schedule?city_id=${city}${dates}${formatsQuery}&lang=${lang}${q ? `&q=${q}` : ''}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_SCHEDULE_EVENT_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_SCHEDULE_EVENT_ERROR,
            error: error
        });
    }
};

export const getMoreScheduleEventAction = (
    id: string,
    city: number,
    dateFrom: Moment,
    dateTo: Moment | null,
    page: number,
    formats: OrderedMap<number, Format>,
    lang: string,
    q?: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_MORE_SCHEDULE_EVENT_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        let formatsQuery = '';
        if (formats) {
            for (let format of formats.toArray()) {
                formatsQuery += '&formats[]=' + format.id;
            }
        }
        const response = await fetcher(`${AFISHA_HOST}/api/v3/events/${id}/schedule?city_id=${city}${dates}${formatsQuery}&lang=${lang}&page=${page}${q ? `&q=${q}` : ''}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_MORE_SCHEDULE_EVENT_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_MORE_SCHEDULE_EVENT_ERROR,
            error: error
        });
    }
};

export const getEventsFormatsAction = (
    id: string,
    city: number,
    dateFrom: Moment,
    dateTo: Moment | null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_SCHEDULE_EVENT_FORMAT_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const response = await fetcher(`${AFISHA_HOST}/api/v3/events/${id}/schedule/filter?city_id=${city}` +
            `${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_SCHEDULE_EVENT_FORMAT_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_SCHEDULE_EVENT_FORMAT_ERROR,
            error: error
        });
    }
};

export const toggleEventsFormatAction = (format: Format) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: TOGGLE_EVENT_FORMAT,
        format
    });
};

export const getPlacesFormatsAction = (
    id: string,
    city: number,
    dateFrom: Moment,
    dateTo: Moment | null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_SCHEDULE_PLACE_FORMAT_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const response = await fetcher(`${AFISHA_HOST}/api/v3/places/${id}/schedule/filter?city_id=${city}` +
            `${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_SCHEDULE_PLACE_FORMAT_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_SCHEDULE_PLACE_FORMAT_ERROR,
            error: error
        });
    }
};

export const togglePlacesFormatAction = (format: Format) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: TOGGLE_PLACE_FORMAT,
        format
    });
};

export const resetFormatsAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_FORMATS
    });
};



// WEBPACK FOOTER //
// ./src/actions/Afisha/schedule.ts